import { ViewModelCritica } from './../models/viewModelCritica';
import { ViewModelResultadoEnvio } from './../models/viewModelResultadoEnvio';
import { HttpClient } from "@angular/common/http";
import { Router } from "@angular/router";
import { environment } from "environments/environment";
import { ViewModelEnviaCobranca } from "../models/enviaCobranca.model";


export class RegistroCobrancaService {

    private strAction = 'api/RegistroCobranca';

    constructor(
        private http: HttpClient,
        private route: Router) {
            
    }

    Post(viewModelEnviaCobranca: ViewModelEnviaCobranca) {    
        return this.http.post<void>(`${environment.TrustApiCobrancaHost}${this.strAction}/EnviaCobrancaBoletoSimplesLote`, viewModelEnviaCobranca);
    }

    getResultadoEnvio(vencimento: string){
        return this.http.get<ViewModelResultadoEnvio>(`${environment.TrustApiCobrancaHost}${this.strAction}/ResultadoEnvio/${vencimento}`);
    }

    getCriticaRegistroBoleto(vencimento: string){
        return this.http.get<ViewModelCritica[]>(`${environment.TrustApiCobrancaHost}${this.strAction}/CriticaRegistroBoleto/${vencimento}`);
    }


}